<template>
  <svg viewBox="0 0 640 640" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M320 64C373 64 416 107 416 160L416 224L224 224L224 160C224 107 267 64 320 64zM192 160L192 224C156.7 224 128 252.7 128 288L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 288C512 252.7 483.3 224 448 224L448 160C448 89.3 390.7 32 320 32C249.3 32 192 89.3 192 160zM192 256L448 256C465.7 256 480 270.3 480 288L480 512C480 529.7 465.7 544 448 544L192 544C174.3 544 160 529.7 160 512L160 288C160 270.3 174.3 256 192 256zM336 352C336 343.2 328.8 336 320 336C311.2 336 304 343.2 304 352L304 448C304 456.8 311.2 464 320 464C328.8 464 336 456.8 336 448L336 352z"
      fill="currentColor"
    />
  </svg>
</template>